import { padNumber } from '@/utils/common';
import { ref, computed, onMounted } from 'vue';

export function useCountdown(targetDate) {
  const timeLeft = ref({});
  const intervalId = ref(null);

  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = targetDate - now;

    if (difference > 0) {
      timeLeft.value = {
        isActive: true,
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft.value = {
        isActive: false,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }
  };

  onMounted(() => {
    calculateTimeLeft();
    intervalId.value = setInterval(calculateTimeLeft, 1000);
  });

  onBeforeUnmount(() => {
    if (intervalId.value) clearInterval(intervalId.value);
  });

  const daysLeft = computed(() => padNumber(timeLeft.value.days || 0));
  const hoursLeft = computed(() => padNumber(timeLeft.value.hours || 0));
  const minutesLeft = computed(() => padNumber(timeLeft.value.minutes || 0));
  const secondsLeft = computed(() => padNumber(timeLeft.value.seconds || 0));
  const isActive = computed(() => timeLeft.value.isActive);

  return {
    isActive,
    daysLeft,
    hoursLeft,
    minutesLeft,
    secondsLeft,
  };
}
